// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function city_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var internalId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "internalId"), null));
  if (internalId.TAG === /* Ok */0) {
    var name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "name"), null));
    if (name.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                internalId: internalId._0,
                name: name._0
              }
            };
    }
    var e = name._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".name" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = internalId._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".internalId" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function category_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var vehicleType = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "vehicleType"), null));
  if (vehicleType.TAG === /* Ok */0) {
    var displayName = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "displayName"), null));
    if (displayName.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                vehicleType: vehicleType._0,
                displayName: displayName._0
              }
            };
    }
    var e = displayName._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".displayName" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = vehicleType._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".vehicleType" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function waitlist_info_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var isWaitlisted = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "isWaitlisted"), null));
  if (isWaitlisted.TAG === /* Ok */0) {
    var waitlistReason = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "waitlistReason"), null));
    if (waitlistReason.TAG === /* Ok */0) {
      var waitlistedAt = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "waitlistedAt"), null));
      if (waitlistedAt.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  isWaitlisted: isWaitlisted._0,
                  waitlistReason: waitlistReason._0,
                  waitlistedAt: waitlistedAt._0
                }
              };
      }
      var e = waitlistedAt._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".waitlistedAt" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = waitlistReason._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".waitlistReason" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = isWaitlisted._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".isWaitlisted" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function status_info_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var status = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "status"), null));
  if (status.TAG === /* Ok */0) {
    var waitlistInfo = waitlist_info_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "waitlistInfo"), null));
    if (waitlistInfo.TAG === /* Ok */0) {
      var lastUpdatedAt = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "lastUpdatedAt"), null));
      if (lastUpdatedAt.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  status: status._0,
                  waitlistInfo: waitlistInfo._0,
                  lastUpdatedAt: lastUpdatedAt._0
                }
              };
      }
      var e = lastUpdatedAt._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".lastUpdatedAt" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = waitlistInfo._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".waitlistInfo" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = status._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".status" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function vehicle_info_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var number = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "number"), null));
  if (number.TAG === /* Ok */0) {
    var category = category_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "category"), null));
    if (category.TAG === /* Ok */0) {
      var bodyType = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "bodyType"), null));
      if (bodyType.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  number: number._0,
                  category: category._0,
                  bodyType: bodyType._0
                }
              };
      }
      var e = bodyType._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".bodyType" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = category._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".category" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = number._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".number" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function owner_info_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var mobile = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "mobile"), null));
  if (mobile.TAG === /* Ok */0) {
    var name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "name"), null));
    if (name.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                mobile: mobile._0,
                name: name._0
              }
            };
    }
    var e = name._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".name" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = mobile._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".mobile" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function basic_info_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var mobile = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "mobile"), null));
  if (mobile.TAG === /* Ok */0) {
    var name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "name"), null));
    if (name.TAG === /* Ok */0) {
      var city = city_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "city"), null));
      if (city.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  mobile: mobile._0,
                  name: name._0,
                  city: city._0
                }
              };
      }
      var e = city._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".city" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = name._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".name" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = mobile._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".mobile" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function lead_data_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var externalId = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "externalId"), null));
  if (externalId.TAG === /* Ok */0) {
    var basicInfo = basic_info_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "basicInfo"), null));
    if (basicInfo.TAG === /* Ok */0) {
      var ownerInfo = owner_info_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "ownerInfo"), null));
      if (ownerInfo.TAG === /* Ok */0) {
        var vehicleInfo = vehicle_info_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "vehicleInfo"), null));
        if (vehicleInfo.TAG === /* Ok */0) {
          var statusInfo = status_info_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "statusInfo"), null));
          if (statusInfo.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      externalId: externalId._0,
                      basicInfo: basicInfo._0,
                      ownerInfo: ownerInfo._0,
                      vehicleInfo: vehicleInfo._0,
                      statusInfo: statusInfo._0
                    }
                  };
          }
          var e = statusInfo._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".statusInfo" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
        }
        var e$1 = vehicleInfo._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".vehicleInfo" + e$1.path,
                  message: e$1.message,
                  value: e$1.value
                }
              };
      }
      var e$2 = ownerInfo._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".ownerInfo" + e$2.path,
                message: e$2.message,
                value: e$2.value
              }
            };
    }
    var e$3 = basicInfo._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".basicInfo" + e$3.path,
              message: e$3.message,
              value: e$3.value
            }
          };
  }
  var e$4 = externalId._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".externalId" + e$4.path,
            message: e$4.message,
            value: e$4.value
          }
        };
}

function t_decode(v) {
  return Decco.listFromJson(lead_data_decode, v);
}

export {
  city_decode ,
  category_decode ,
  waitlist_info_decode ,
  status_info_decode ,
  vehicle_info_decode ,
  owner_info_decode ,
  basic_info_decode ,
  lead_data_decode ,
  t_decode ,
  
}
/* No side effect */
